import React from 'react'
import Img from 'components/shared/Image/Img'
import { Text, RichText } from 'components/typo'
import Button from 'components/shared/Button'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ResourceCardDetails = ({
  className,
  theme,
  icon,
  title,
  text,
  button,
}) => {
  return (
    <div className={cx(className, css.ResourceCardDetails, theme)}>
      {icon && icon.media && (
        <div className={css.icon}>
          <Img {...icon} />
        </div>
      )}
      <div className={css.textContent}>
        {title && (
          <RichText
            className={css.title}
            size="big"
            theme="white"
            type="Title"
            text={title}
          />
        )}
        {text && (
          <Text className={css.text} size="small" theme="white">
            {text}
          </Text>
        )}
      </div>
      {button && (
        <Button
          {...button}
          className={css.button}
          buttonClassName={css.buttonLink}
          fullWidth
          theme={theme}
        />
      )}
    </div>
  )
}

ResourceCardDetails.defaultProps = {}

export default ResourceCardDetails
